/* app/js/src/components/external-mam/external-mam-providers-layout/external-mam-gateways-card.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 20px;
  width: 290px;
  height: 280px;
  position: relative;
  background-color: #ffffff;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid;
  border-color: rgba(0, 0, 0, 0.14);
}
:host .frame {
  display: flex;
  width: 250px;
  align-items: center;
  gap: 12px;
  position: relative;
  flex: 0 0 auto;
}
:host .frame .icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  position: relative;
  flex: 0 0 auto;
}
:host .frame .image {
  position: relative;
  width: 40px;
  height: 40px;
}
:host .frame .title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  flex: 1;
  flex-grow: 1;
}
:host .frame .title .heading {
  position: relative;
  align-self: stretch;
  margin-top: -1px;
  font-family: "Open Sans-SemiBold", Helvetica;
  font-weight: 600;
  color: rgb(35, 47, 58);
  font-size: 18px;
  letter-spacing: 0;
  line-height: 30px;
}
:host .frame .title .status {
  position: relative;
  align-self: stretch;
  font-family: "Open Sans-Regular", Helvetica;
  font-weight: 400;
  color: rgb(114, 125, 139);
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
}
:host .description {
  display: flex;
  width: 250px;
  align-items: center;
  gap: 10px;
  height: 50%;
  position: relative;
  flex: 0 0 auto;
}
:host .description .body {
  position: relative;
  flex: 1;
  margin-top: -1px;
  font-family: "Open Sans-Regular", Helvetica;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
}
:host .outlined-large {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 9px 16px;
  position: relative;
  align-self: stretch;
  width: 100%;
  flex: 0 0 auto;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid;
  border-color: rgb(45, 187, 252);
  color: rgb(45, 187, 252);
  cursor: pointer;
}
:host .outlined-large:hover,
:host .outlined-large:active {
  color: rgb(255, 255, 255);
  border-color: #2dbbfc;
  background-color: #2dbbfc;
}
:host .outlined-large .buttons-medium {
  position: relative;
  width: fit-content;
  margin-top: -1px;
  font-family: "Open Sans-Bold", Helvetica;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0;
  line-height: 24px;
  white-space: nowrap;
}
/*# sourceMappingURL=external-mam-gateways-card.component.css.map */
